import React, { useEffect, useState } from "react";
import ReflectingJobMarket from "./ReflectingJobMarket";
import ActionPlanForJob from "./ActionPlanForJob";
import "./BlogDetails.css";
import JobHuntingTips from "./JobHuntingTips";
import Conculation from "./Conculation";
import { MdArrowRight } from "react-icons/md";
import { IoIosArrowDown } from "react-icons/io";

import { Link, scroller } from "react-scroll";

import MoreBlog from "./MoreBlog";
import { Button } from "@material-tailwind/react";
import CommentReview from "./CommentReview";

import Subscribe from "../../components/ELearning/Subscribe";
export default function BlogDetails() {
  const [activeLink, setActiveLink] = useState("reflecting");
  const [open, setOpen] = useState(false);

  const toggleOpen = () => setOpen((cur) => !cur);

  const handleSetActive = (to: string) => {
    setActiveLink(to);
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentSection = scroller.getActiveLink() || "reflecting"; // Default to 'reflecting' if none is active
      if (currentSection !== activeLink) {
        setActiveLink(currentSection);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeLink]);

  const jobSearch = `Job Search Tips 2024 Use our Tailwind CSS collapse for your website. You can use
  if for accordion, collapsible items and much more.`;

  return (
    <>
      <div className="blog_details mt-10 border-2 p-5 ">
        <div className=" mb-10 flex ">
          <div className="flex items-center bg-[#e9eef1] p-4 rounded-full">
            <p>Blog</p>
            <p>
              <MdArrowRight style={{ width: "20px", height: "20px" }} />
            </p>
            <p>Job Search</p>
          </div>
        </div>
        <div className="grid md:grid-cols-2 sm:grid-cols-1 gap-x-20">
          <div>
            <img
              className="rounded-lg"
              src="/blog-details/blog-details-hero.png"
              alt=""
            />
          </div>
          <div>
            <div className="flex gap-x-3">
              <p className="opacity-50">January 11, 2024 </p>
              <button className="bg-[#fc1c26] text-white px-1 rounded text-[12px]">
                Job search
              </button>
            </div>

            <Button
              onClick={toggleOpen}
              className="bg-transparent border leading-[56px] mt-5 border-black text-black w-full text-left flex items-center justify-between "
            >
              <div className=" ">
                <p className="text-[35px] font-bold">
                  {`${open ? jobSearch : `${jobSearch?.slice(0, 20)}...`}`}
                </p>
              </div>

              {open ? (
                ""
              ) : (
                <IoIosArrowDown
                  style={{
                    width: "40px",
                    height: "40px",
                    rotate: open ? "180deg" : "",
                  }}
                />
              )}
            </Button>

            <div className="flex ">
              <div className="flex items-center gap-x-5 mt-5 bg-[#e9eef1] rounded-full px-3">
                <img
      src="/blog-details/blog-img-details.png"
      className="blog_iconImg h-9 w-auto object-contain"
      alt="Careerflow Team"
    />
                <p className="font-bold">Careerflow Team</p>
              </div>
            </div>
          </div>
        </div>
        {/* Ads */}
        <div className=" relative rounded-sm mt-5">
          <img src="/blog/tips-add.png" alt="" className="w-full h-full" />
          <div className="absolute left-0 top-0 w-full h-full flex items-center justify-center md:text-3xl">
            Ads
          </div>
        </div>
        <div className="grid md:grid-cols-12 sm:grid-cols-12 mt-5">
          <div className="md:col-span-3 sm:col-span-12 table-content md:sticky sm:static top-10 md:h-screen sm:h-[100%]">
            <h4 className="font-bold ">Table of Contents</h4>
            <ul>
              <li className="">
                <Link
                  className={`${
                    activeLink === "reflecting"
                      ? "bg-[#fc1c26] text-white border-l-[2px] border-[#2544b8]"
                      : ""
                  }`}
                  activeClass="active"
                  to="reflecting"
                  spy={true}
                  smooth={true}
                  offset={-5}
                  duration={500}
                  onSetActive={handleSetActive}
                >
                  <span>Reflecting on 2023: Key Job </span>
                </Link>
              </li>
              <li>
                <Link
                  className={`${
                    activeLink === "action-plan"
                      ? "bg-[#fc1c26] text-white border-l-[2px] border-[#2544b8]"
                      : ""
                  }`}
                  activeClass="active"
                  to="action-plan"
                  spy={true}
                  smooth={true}
                  offset={-5}
                  duration={500}
                  onSetActive={handleSetActive}
                >
                  {" "}
                  <span>Action Plan for Job Seekers</span>
                </Link>
              </li>
              <li className="">
                <Link
                  className={`${
                    activeLink === "job-hunting"
                      ? "bg-[#fc1c26] text-white border-l-[2px] border-[#2544b8]"
                      : ""
                  }`}
                  activeClass="active"
                  to="job-hunting"
                  spy={true}
                  smooth={true}
                  offset={-5}
                  duration={500}
                  onSetActive={handleSetActive}
                >
                  <span>Job Hunting Tips 2024</span>
                </Link>
              </li>
              <li>
                <Link
                  className={`${
                    activeLink === "conculation"
                      ? "bg-[#fc1c26] text-white border-l-[2px] border-[#2544b8]"
                      : ""
                  }`}
                  activeClass="active"
                  to="conculation"
                  spy={true}
                  smooth={true}
                  offset={-5}
                  duration={500}
                  onSetActive={handleSetActive}
                >
                  <span>Conculation</span>
                </Link>
              </li>
              {/* Add more links for other sections */}
            </ul>
            <div className="md:h-[821.54px] mt-48 w-full">
              <img
                src="/blog/add-red.png"
                alt=""
                className="w-[252.24px] h-[207.3]"
              />
            </div>
          </div>
          <div className="md:col-span-9 sm:col-span-12 ">
            <article className=" md:px-[40px] sm:px-0">
              <section>
                <p>
                  The year 2023 has been a whirlwind for the job industry. From
                  the dizzying heights of record valuations to the sobering
                  reality of widespread layoffs, the landscape has shifted
                  dramatically. Companies once considered unstable have even
                  announced workforce reductions. While the reasons are complex
                  and varied, the common thread is clear: the tech sector is
                  undergoing a period of recalibration.
                </p>
                <p>
                  This recalibration presents both challenges and opportunities
                  for job seekers in 2024. The competition for open positions
                  will likely be fiercer, demanding a well-honed skill set and a
                  strategic approach. But for those who are prepared, there is
                  still immense potential for success.
                </p>
                <p>
                  In this blog, we'll delve into the specific trends shaping the
                  2024 job market, drawing insights from the layoff data of
                  2023. We'll explore the skills and experiences that are most
                  in demand, the companies that are still hiring, and the
                  strategies you can employ to stand out from the crowd. Whether
                  you're a seasoned professional or a recent graduate, this blog
                  will equip you with the knowledge and guidance you need to
                  navigate the job market with confidence.
                </p>
                <p>
                  So, buckle up and get ready to dive into the exciting, though
                  uncertain, world of job search in 2024. We'll be your guide as
                  we explore the layoff landscape, identify emerging trends, and
                  draft a course for your professional success.
                </p>
                <p>
                  Remember, even in challenging times, opportunity awaits those
                  who are prepared. Let's get started!
                </p>
              </section>
              {/* Reflecting on 2023: Key Job Market Insights */}
              <section id="reflecting">
                <h1 className="text-[50px] font-bold">
                  Reflecting on 2023: Key Job Market Insights
                </h1>
                <ReflectingJobMarket />
              </section>
              {/* Action Plan */}
              <section id="action-plan">
                <h1 className="text-[50px] font-bold">
                  Action Plan for Job Seekers in 2024
                </h1>
                <ActionPlanForJob />
              </section>
              {/*Job Hunting Tips */}
              <section id="job-hunting">
                <h1 className="text-[50px] font-bold">Job Hunting Tips 2024</h1>
                <JobHuntingTips />
              </section>
              {/*Conculation*/}
              <section id="conculation">
                <h1 className="text-[50px] font-bold">Conculatio</h1>
                <Conculation />
              </section>
              <section>
                <div className=" relative rounded-sm mt-5 ">
                  <img
                    src="/blog/tips-add.png"
                    alt=""
                    className="w-full h-full"
                  />
                  <div className="absolute left-0 top-0 w-full h-full flex items-center justify-center md:text-3xl">
                    Ads
                  </div>
                </div>
                <CommentReview />
              </section>
            </article>
          </div>
        </div>

        {/* More Blog */}

        <div className="mt-10 ">
          <h1 className="text-[50px] text-center font-bold">Discover More</h1>
          <MoreBlog />
        </div>
      </div>
      {/* Subscription part */}
      <Subscribe />
    </>
  );
}
